// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3bxbF","title":"AfterFrontImage_title__1oHKk"};